import { render } from "./FrontendDashboard.vue?vue&type=template&id=40f00ec4&scoped=true"
import script from "./FrontendDashboard.vue?vue&type=script&lang=js"
export * from "./FrontendDashboard.vue?vue&type=script&lang=js"

import "./FrontendDashboard.vue?vue&type=style&index=0&id=40f00ec4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f00ec4"]])

export default __exports__